import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, getApi } from 'services/_api';
import { CHANNEL, PATH_DETRAN_CNH } from 'services/_path';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, ImprimirRenachRequest } from './types';

// ACTIONS
import { imprimirRenachSuccess, imprimirRenachFailure } from './actions';

function* imprimirRenach(request: ReducerAction) {
	const { payload }: { payload: ImprimirRenachRequest } = request;

	const response: ApiResponse = yield call(
		getApi,
		PATH_DETRAN_CNH,
		`imprimir-renach/${CHANNEL}/${payload.cpfCidadao}/${payload.cpfUsuarioLogado}`,
		{},
	);

	if (response.status === 200) {
		yield put(imprimirRenachSuccess(response));
	} else if (response.error) {
		yield put(imprimirRenachFailure(response.error));
	}
}

export default all([takeLatest(Types.IMPRIMIR_RENACH_REQUEST, imprimirRenach)]);
